import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lineBreaks' })
export class LineBreaksPipe implements PipeTransform {
  transform(val) {
    const v = val.replaceAll(/\n/g, '<br />');
    return v;
  }
}
